import { motion } from "framer-motion";
import { useLang } from "../lib/i18n";

export const PageHeader = ({ tone, ghost, title, accent = "#F4B8C6" }) => {
  const { c } = useLang();
  return (
    <section className="relative overflow-hidden" style={{ backgroundColor: tone }} data-testid="page-header">
      <span
        aria-hidden
        className="absolute -right-4 -bottom-12 font-serif-display italic font-light text-[34vw] sm:text-[18vw] leading-none text-[#FAFAF1]/[0.08] select-none pointer-events-none whitespace-nowrap"
      >
        {ghost}
      </span>
      <span aria-hidden className="absolute left-6 top-8 text-lg select-none" style={{ color: accent, opacity: 0.5 }}>
        ✦
      </span>
      <div className="relative max-w-6xl mx-auto px-6 py-20 sm:py-28">
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          className="text-[11px] uppercase tracking-[0.4em] text-[#FAFAF1]/60"
        >
          Paulina <span style={{ color: accent }}>&amp;</span> Louie · {c.hero.dateline}
        </motion.p>
        <span className="block overflow-hidden">
          <motion.h1
            initial={{ y: "105%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
            className="mt-5 font-serif-display font-light text-5xl sm:text-6xl lg:text-7xl text-[#FAFAF1]"
          >
            {title}
            <span className="italic" style={{ color: accent }}>
              .
            </span>
          </motion.h1>
        </span>
        <motion.div
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 1, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="origin-left mt-10 h-px w-24"
          style={{ backgroundColor: accent }}
        />
      </div>
    </section>
  );
};
